var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsAStructure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    id: "svg_2",
    height: 2,
    width: 1,
    y: 19,
    x: 1055,
    stroke: "#000",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    stroke: "#000",
    strokeWidth: 0,
    opacity: "NaN",
    d: "m106.89446,250.34259",
    id: "svg_10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#000",
    d: "m5.90886,75.13046l45.51706,-70.34455l45.51706,70.34455l-91.03413,0l0.00001,0z",
    id: "svg_19"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Noto Sans JP",
    fontSize: 24,
    strokeWidth: 0,
    id: "svg_6",
    y: 62.37189,
    x: 33.79446,
    stroke: "#000",
    fill: "#000000",
    fontWeight: "normal",
    fontStyle: "normal"
  }, "IsA"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsAStructure);
export default __webpack_public_path__ + "static/media/IsAStructure.655b02baf6949f42739eb9404df7c367.svg";
export { ForwardRef as ReactComponent };